import { Component } from 'react';
import LockoutButton from './lockout-button';

import { shouldShowUsageEmailCheckbox } from '../../../../services/utils/personnel';

import './personnel-row-css.css';

class PersonnelRow extends Component {
  startEdit() {
    const { personnel_data, start_edit } = this.props;
    start_edit(personnel_data);
  }

  async setLockout() {
    const { set_personnel_lockout_status, personnel_data } = this.props;
    const newStatus = !personnel_data.lockout;
    await set_personnel_lockout_status(personnel_data.id, newStatus);
  }

  async toggleCheck() {
    this.setState({ isChecked: !this.state.isChecked });
  }

  render() {
    const { personnel_data } = this.props;
    const lockedout = personnel_data.lockout;
    let lockedOutText = '';

    //TODO: GET IT FROM SERVER / USER ????
    const isDataUsageChecked = personnel_data.send_usage_email;

    if (lockedout) {
      lockedOutText = <span className="locked_out_message">[Locked out]</span>;
    }

    const shouldShowCheckbox = shouldShowUsageEmailCheckbox(personnel_data.role);

    return (
      <tr key={personnel_data.id} className="personnel_table_row">
        <td>
          {personnel_data.first_name + ' ' + personnel_data.last_name}
          {lockedOutText}
        </td>
        <td>{personnel_data.email}</td>
        <td>{personnel_data.role.name}</td>
        <td>{personnel_data.organizations.organization_names.join(', ')}</td>
        <td
          style={{
            textAlignLast: 'center',
          }}
        >
          {shouldShowCheckbox && (
            <input
              name="isSendDataUsageEmail"
              type="checkbox"
              className="regular-checkbox"
              checked={isDataUsageChecked}
              disabled={true}
            />
          )}
        </td>
        <td>
          <LockoutButton lockedout={personnel_data.lockout} click_func={this.setLockout.bind(this)} />
        </td>
        <td onClick={this.startEdit.bind(this)} className="edit_personnel_button">
          Edit<i className="fa fa-pencil edit_personnel_icon"></i>
        </td>
      </tr>
    );
  }
}

export default PersonnelRow;
